import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';

import { rikHttpClient } from 'services/httpClient';
import IGetSearchedInterventionRequestParams from 'services/httpClient/responses/intervention/IGetSearchedInterventionRequestParams';
import IGetSearchedInterventionResponse from 'services/httpClient/responses/intervention/IGetSearchedInterventionResponse';

import { interventionActions } from '../index';
import { IGetSearchedInterventionRequestAction } from '../reducers/getSearched/request';

function* getSearched(
  action: PayloadAction<IGetSearchedInterventionRequestAction>,
) {
  const params: IGetSearchedInterventionRequestParams = {
    request: action.payload.data.request,
  };
  try {
    const response: AxiosResponse<IGetSearchedInterventionResponse> =
      yield call(
        rikHttpClient.get,
        `interventions/${action.payload.data.interventionPartnershipId}/rik_search_bar`,
        {
          params,
        },
      );
    if (!response.data.interventions.length) {
      yield put(
        interventionActions.getSearchedInterventionSuccessWithoutData({
          message: 'No Interventions Found',
        }),
      );
      return;
    }
    yield put(
      interventionActions.getSearchedInterventionSuccessWithData({
        list: response.data.interventions,
      }),
    );
  } catch (err: any) {
    action.payload.functions.error(err);
    yield put(interventionActions.getSearchedInterventionFailure());
  }
}

export default getSearched;
